<template>
    <div>
        <app-nav :changeView="changeView"/>
        <component :is="view" :person="person" :client-id="clientId" />
    </div>
</template>
<script>
import PersonalInformation from './PersonalInformation.vue';
import EntryHistory from './EntryHistory.vue';
import Nav from './Nav.vue';
    export default {
        components: {
            appNav: Nav,
            appPersonalInformation: PersonalInformation,
            appEntryHistory: EntryHistory
        },
        props: {
            person: {
                type: Object,
                required: true
            },
            clientId: {
                type: Number,
                required: true
            }
        },
        data(){
            return {
                theView: 'person-info'
            }
        },
        methods: {
            changeView(view){
                this.theView = view;
            },
            cleanFields(){
                this.theView = 'person-info';
            }
        },
        computed: {
            view(){
                const views = {
                    'person-info': 'appPersonalInformation',
                    'entry-history': 'appEntryHistory'
                }
                return views[this.theView];
            }
        },

        created(){
             this.$bus.$on('person-card.clean', this.cleanFields);  
        }
    }
</script>